<template>
  <page>
    <v-card>
      <v-card-text>
        <v-radio-group v-model="form.marine" row :mandatory="true" class="ml-3 pa-0">
          <v-radio :label="labels.cargo" value="cargo"></v-radio>
          <v-radio :label="labels.hull" value="hull"></v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>
    <v-spacer class="mt-2"></v-spacer>
    <div v-if="form.marine === 'cargo'">
      <CargoSchedule></CargoSchedule>
    </div>
    <div v-else-if="form.marine === 'hull'">
      <HullSchedule></HullSchedule>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import CargoSchedule from '@/components/reports/fireSchedule/CargoSchedule'
import HullSchedule from '@/components/reports/underwriting/uwHullSched'
export default {
  data() {
    return {
      labels: {
        cargo: 'Cargo',
        hull: 'Hull'
      },
      form: {
        marine: 'cargo'
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    CargoSchedule,
    HullSchedule
  }
}
</script>

<style>

</style>
